import { h } from 'preact'
import Phrase from '../../libs/translationsUtils/phrase'

export type ZendeskHit = {
  title: string,
  url: string,
  content: string
}

const ZendeskResults = ({ hit }: { hit: ZendeskHit }) => {
  return (
    <div className='qa-topic-block thread-list-item forum-list-view-spacing thread-list-item--zendesk thread--unread'>
      <span className='thread-list-item--index-label'>
        <Phrase m='Forum' p='federated.search.zendesk' />
      </span>
      <h4 className='thread-list-block__title'>
        <a className='qa-topic-title thread-list-block__title-link' href={hit.url} target='_blank'>{ hit.title }</a>
      </h4>
      <p className='thread-list-block__content qa-topic-content'>
        <a href={hit.url} target='_blank'>{ hit.content }</a>
      </p>
    </div>
  )
}

export default ZendeskResults
